interface MarginModeModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentMode: 'cross' | 'isolated';
  onConfirm: (mode: 'cross' | 'isolated') => void;
}

export function MarginModeModal({ isOpen, onClose, currentMode, onConfirm }: MarginModeModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-[#0e0f10] border border-[#2d3748] rounded-lg p-4 w-[340px] max-w-[90vw]" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-white font-semibold text-[14px]">Margin Mode</h3>
          <button
            onClick={onClose}
            className="text-[#6c7884] hover:text-white transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Options */}
        <div className="space-y-2">
          {/* Cross Margin Option */}
          <button
            onClick={() => {
              onConfirm('cross');
              onClose();
            }}
            className={`w-full p-3 rounded-md text-left transition-all ${
              currentMode === 'cross'
                ? 'bg-[#3fb68b]/20 border border-[#3fb68b]'
                : 'bg-[#0b0c0d] border border-[#2d3748] hover:border-[#3d444d]'
            }`}
          >
            <div className="flex items-center justify-between mb-1">
              <span className={`text-[12px] font-semibold ${currentMode === 'cross' ? 'text-[#3fb68b]' : 'text-white'}`}>
                Cross
              </span>
              {currentMode === 'cross' && (
                <svg className="w-4 h-4 text-[#3fb68b]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <p className="text-[12px] text-[#6c7884] leading-relaxed">
              All positions share the same margin pool. Profits from one position can offset losses from another. Higher capital efficiency but all positions share liquidation risk.
            </p>
          </button>

          {/* Isolated Margin Option */}
          <button
            onClick={() => {
              onConfirm('isolated');
              onClose();
            }}
            className={`w-full p-3 rounded-md text-left transition-all ${
              currentMode === 'isolated'
                ? 'bg-[#3fb68b]/20 border border-[#3fb68b]'
                : 'bg-[#0b0c0d] border border-[#2d3748] hover:border-[#3d444d]'
            }`}
          >
            <div className="flex items-center justify-between mb-1">
              <span className={`text-[12px] font-semibold ${currentMode === 'isolated' ? 'text-[#3fb68b]' : 'text-white'}`}>
                Isolated
              </span>
              {currentMode === 'isolated' && (
                <svg className="w-4 h-4 text-[#3fb68b]" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <p className="text-[12px] text-[#6c7884] leading-relaxed">
              Each position has its own dedicated margin. Losses are limited to the margin assigned to that position. Lower risk of total liquidation but less capital efficient.
            </p>
          </button>
        </div>
      </div>
    </div>
  );
}
